<template>
    <div class="ses-content">
        <content-header></content-header>
        <div class="page-content">
            <div class="container content">
                <slide-y-up-transition mode="out-in" origin="center top">
                    <router-view></router-view>
                </slide-y-up-transition>
            </div>
        </div>
    </div>
</template>
<script>
import { SlideYUpTransition } from 'vue2-transitions'
import ContentHeader from './ContentHeader.vue'

export default {
    name: 'nosidebar-layout',
    components: {
        SlideYUpTransition,
        ContentHeader
    }
}
</script>
